import styled from 'styled-components';

export const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  margin-left: 8px;
  font-size: 10px;
  font-weight: 500;
  border-radius: 4px;
  border: 1px solid;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.2s ease;

  ${({ $isRead }) =>
    $isRead
      ? `
    color: #D23176;
    border-color: #D23176;

    &:hover {
      background-color: #D23176;
      color: white;
    }
  `
      : `
    color: #2dce89;
    border-color: #2dce89;

    &:hover {
      background-color: #2dce89;
      color: white;
    }
  `}

  &:active {
    transform: scale(0.98);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
`;

export const TextLabel = styled.span`
  line-height: 1;
`;
